module.exports = __webpack_public_path__ + "img/medium_white.fef5925e.svg";